import { type DragEvent, useCallback, useState } from "react";

const hasFiles = (e: DragEvent) => Array.from(e.dataTransfer.types).includes("Files");

export const useFileDrop = (onFiles: (files: File[]) => void, disabled?: boolean) => {
	const [isDragging, setIsDragging] = useState(false);

	const onDragOver = useCallback(
		(e: DragEvent) => {
			if (disabled || !hasFiles(e)) return;
			e.preventDefault();
			setIsDragging(true);
		},
		[disabled],
	);

	const onDragLeave = useCallback((e: DragEvent) => {
		if (e.currentTarget.contains(e.relatedTarget as Node | null)) return;
		setIsDragging(false);
	}, []);

	const onDrop = useCallback(
		(e: DragEvent) => {
			if (disabled || !hasFiles(e)) return;
			e.preventDefault();
			setIsDragging(false);
			onFiles(Array.from(e.dataTransfer.files));
		},
		[disabled, onFiles],
	);

	return { isDragging, dropProps: { onDragOver, onDragLeave, onDrop } };
};
